import React from 'react';
import {
  InfiniteScroll,
} from '@marageti/z4-lib';
import {
  Box, Skeleton, Stack, Typography,
} from '@mui/material';
import { TripRequest } from '@marageti/z4-sdk/lib/travel';
import TripRequestCard from '../list-cards/trip-request-cards/all-card';
import useTripRequestSearch from '../../hooks/use-trip-request-search';

interface DefaultSearch {
  [key: string]: string | string[];
  order: string;
  sort: string;
  status: string[];
  traveler: string;
}

const defaultSearch: DefaultSearch = {
  order: 'desc',
  sort: 'createdAt',
  status: [],
  traveler: '',
};

const InfiniteTravelerTripRequestList = ({
  travelerId = undefined,
}: {
  travelerId?: string,
}) => {
  defaultSearch.traveler = travelerId || '';

  const {
    tripRequests,
    error,
    hasMore,
    isLoading,
    loadMore,
    totalHits,
  } = useTripRequestSearch(defaultSearch);

  return (
    <Box>
      {isLoading ? (
        <Skeleton variant="rounded" sx={{ mb: 2, height: '24px', width: '100px' }} />
      ) : (
        <Typography variant="bodyBold" mb={2}>
          {`Trip Requests (${totalHits})`}
        </Typography>
      )}
      <Stack spacing={1}>
        <InfiniteScroll
          error={error}
          hasMoreItems={hasMore}
          isLoading={isLoading}
          loadMoreItems={loadMore}
          stackProps={{ sx: { minHeight: '0px' } }}
        >
          {tripRequests?.flatMap((item: TripRequest) => (
            <TripRequestCard
              key={item.id}
              tripRequest={item}
            />
          ))}
        </InfiniteScroll>
      </Stack>
    </Box>
  );
};

export default InfiniteTravelerTripRequestList;
